import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AnalyticsService, NgxBarGroup, CategoryViewsRequest } from '../../services/api';

@Component({
  selector: 'app-youtube-category-views',
  templateUrl: './youtube-category-views.component.html',
  styleUrls: ['./youtube-category-views.component.scss']
})
export class YoutubeCategoryViewsComponent implements OnInit, OnChanges {
  @Input() viewsize: [number, number] = [1000, 520];
  @Input() disableResize: boolean = false;
  @Input() startDate?: Date | null;
  @Input() endDate?: Date | null;

  showXAxis = true;
  showYAxis = true;
  showLegend = false;
  xAxisLabel = 'Views';
  yAxisLabel = 'Category';

  // Computed based on tile mode
  get showXAxisLabel(): boolean {
    return !this.disableResize;
  }
  get showYAxisLabel(): boolean {
    return !this.disableResize;
  }
  get yAxisMaxLabelLength(): number {
    return this.disableResize ? 12 : 25;
  }

  chartData: NgxBarGroup[] = [];
  loading = false;
  errorMsg = '';

  private readonly allowedCategories = new Set([
    'Animals',
    'Animal',
    'Family & Social Relationships',
    'Nature & Weather',
    'Home Environment',
    'Religion and Moral Values',
    'Literacy & Numeracy',
    'School & Learning',
    'Transport & Places',
    'Food & Healthy Living',
    'Creative Arts',
    'People & Occupations'
  ]);

  constructor(private readonly analyticsService: AnalyticsService) {}

  ngOnInit(): void {
    this.fetchCategoryViews();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['startDate'] || changes['endDate']) {
      this.fetchCategoryViews();
    }
  }

  private fetchCategoryViews(): void {
    this.loading = true;
    this.errorMsg = '';

    const body: CategoryViewsRequest = {
      metric: 'total',
      startDate: this.startDate ? this.startDate.toISOString() : undefined,
      endDate: this.endDate ? this.endDate.toISOString() : undefined
    };

    this.analyticsService.analyticsGetCategoryViewsReportPost(body).subscribe({
      next: data => {
        // Filter to only include allowed categories
        this.chartData = (data ?? []).filter(item => 
          this.allowedCategories.has(item.name ?? '')
        );
        this.loading = false;
        if (this.disableResize) {
          setTimeout(() => {
            this.viewsize = [this.viewsize[0], this.viewsize[1]];
          });
        }
      },
      error: err => {
        console.error(err);
        this.errorMsg = 'Failed to load YouTube category views.';
        this.loading = false;
      }
    });
  }

  onResize(event: any) {
    if (this.disableResize) return;
    const w = event?.target?.innerWidth ?? 1200;
    this.viewsize = [Math.max(720, Math.floor(w * 0.8)), 520];
  }
}
